const NAME = 'sw';

export const SW_UPDATE_ACTIVATED = `${NAME}/SW_UPDATE_ACTIVATED`;
export const SW_RELOADING_START = `${NAME}/SW_RELOADING_START`;
